export const RUN_SECTION_LABELS = { name: 'Run name', driver: 'Driver', stop_plan: 'Stops' };

export const RUN_STATUS_LABELS = {
  safe: 'Ready for your review',
  already_satisfied: 'Already matches online',
  conflict: 'Newer online activity',
  unavailable: 'Current online information unavailable',
  dependency_blocked: 'Waiting on another run change',
};

export const RUN_DECISION_LABELS = {
  approve: 'Use offline change',
  override: 'Replace newer online change',
  keep_online: 'Discard offline change',
};

export const cachedRunDriverLabel = (id, item, side) => {
  if (!id) return 'Unassigned';
  if (side === 'current' && item.current?.driver?.name) return item.current.driver.name;
  return item.driver_labels?.[id] || id;
};

export const cachedRunStopLabel = (id, item, side) => {
  if (side === 'current') {
    const stop = item.current?.populated_stops?.find(candidate => candidate.order_id === id);
    const order = stop?.order;
    if (order?.internal_order_number) return `#${order.internal_order_number}`;
    if (order?.recipient_name) return order.recipient_name;
  }
  return item.order_labels?.[id] || id;
};

export const cachedRunSectionValue = (section, value, item, side) => {
  if (value?.missing) return 'Run no longer exists online';
  if (value?.evidence_unavailable) return 'Could not refresh';
  if (section === 'name') return value?.name || 'Unnamed run';
  if (section === 'driver') return cachedRunDriverLabel(value?.user_id, item, side);
  const stops = value?.stops || [];
  return stops.length
    ? stops.map(stop => cachedRunStopLabel(stop.order_id, item, side)).join(' → ')
    : 'No stops';
};
